import { DataTable, MainButton, PageWrapper, STATUSPAGE } from '@repo/ui';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'reactstrap';

import { makeColumnsCourse } from '../common/columns/columns-courses-list';
import { ModalNewCourse } from '../components/modalNewCourse';
import { useCourse } from '../hooks/useCourse';

export const Course = () => {
  //Hooks
  const navigate = useNavigate();

  const {
    handleToggleModal,
    requestCourseList,
    requestCourseDelete,
    requestCourseGetById,
    resetForm,
    formik,
    isModalOpen,
    coursesUser: coursesList,
    listStatus,
    loadingCourseById,
  } = useCourse();

  // Constants
  const noDataConfig = {
    noDataTitle: 'Nenhum curso encontrado',
    noDataDescription: 'Não há cursos cadastrados no momento.',
  };

  //Functions
  const handleEditCourse = (courseId: string) => {
    handleToggleModal();
    requestCourseGetById({ id: courseId });
    navigate(null, {
      state: { id: courseId, name: courseId },
    });
  };

  const handleDeleteCourse = (courseId: string) => {
    requestCourseDelete({ id: courseId });
  };

  useEffect(() => {
    requestCourseList();
  }, []);

  return (
    <PageWrapper title="Cursos">
      <ModalNewCourse
        formik={formik}
        resetForm={resetForm}
        isOpen={isModalOpen}
        toggleModal={handleToggleModal}
        loading={loadingCourseById === STATUSPAGE.LOADING}
      />

      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold">Cursos</h4>
          <p className="text-muted mb-0">
            Cadastre aqui os cursos disponíveis para as entidades e seleções de
            estágios.
          </p>
        </div>

        <MainButton
          onClick={() => {
            handleToggleModal();
          }}
        >
          <i className="ri-add-line" style={{ fontSize: '1rem' }}></i>
          Novo Curso
        </MainButton>
      </div>

      <Card className="p-3">
        <DataTable
          noDataTitle={noDataConfig.noDataTitle}
          noDataDescription={noDataConfig.noDataDescription}
          data={coursesList}
          actions={[
            {
              id: 1,
              name: 'Editar',
              label: 'Editar',
              onPress: (course) => handleEditCourse(course.id),
              classNameColorIcon: 'primary',
              nameFeatherIcon: 'edit',
            },
          ]}
          loading={listStatus === STATUSPAGE.LOADING}
          handleDelete={(id) => handleDeleteCourse(id)}
          canSearch={true}
          defaultSortAsc={true}
          columns={makeColumnsCourse()}
          defaultSortFieldId={1}
          keysSearch={['nome']}
        />
      </Card>
    </PageWrapper>
  );
};
